import { PartnerCards } from "@/modules/settings/logistics/PartnerCards";
import { RecentChecks } from "@/modules/settings/logistics/RecentChecks";
import { TrackingSettingsForm } from "@/modules/settings/logistics/TrackingSettingsForm";
import { UnrecognisedStatuses } from "@/modules/settings/logistics/UnrecognisedStatuses";

/**
 * Settings → Logistics partners (#527, Part B).
 *
 * Four things about shipment tracking on one page, in the order someone asks
 * about them: who follows the parcels (the partners, and whether each is
 * connected), the rules for flagging one that has gone quiet, what the last
 * checks did, and which courier statuses nobody has taught the table yet.
 *
 * Reading needs `settings.sync.view`. Running a check needs
 * `settings.sync.trigger` and changing the rules `settings.company.manage`; the
 * parts of the page that need them are absent or locked for anyone without, and
 * the server refuses them regardless. No key is shown or taken anywhere on it:
 * partner keys are deployment secrets.
 *
 * One scrolling column, as Shopify Sync is, not four panes fighting for the
 * height of a phone.
 */
export function LogisticsPartners() {
  return (
    <div className="mx-auto max-w-6xl space-y-10 pb-6">
      <PartnerCards />
      <TrackingSettingsForm />
      <RecentChecks />
      <UnrecognisedStatuses />
    </div>
  );
}
